import React, { useState } from "react";
import { Grid, TextField, InputAdornment, Button } from "@mui/material";
import { Search, Add } from "@mui/icons-material";
import ParserConfigCreate from "./ParserConfigCreate";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hoc/AuthProvider/useAuth";
import { Permissions } from "../../config/permissions";

interface ParserConfigFilterProps {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  searchText: string;
  onSearchChange: (value: string) => void;
  loadParserConfigs: () => void;
  deviceTypeId: number;
}

const ParserConfigFilter: React.FC<ParserConfigFilterProps> = ({
  setPage,
  searchText,
  onSearchChange,
  loadParserConfigs,
  deviceTypeId,
}) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const navigate = useNavigate();
  const { havePermission } = useAuth();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, sm: "auto" }}>
          <TextField
            fullWidth
            placeholder={"Parser ara"}
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {havePermission(Permissions.ParserConfig_Create) && (
          <Grid size={{ xs: 12, sm: "auto" }} container alignItems="center" sx={{ gap: 1 }}>
            <Button
              size="medium"
              variant="contained"
              startIcon={<Add />}
              onClick={() => setisModalOpen(true)}
              sx={{
                backgroundColor: "var(--color-primary)",
                "&:hover": { backgroundColor: "var(--color-primary-dark)" },
                textTransform: "none",
                borderRadius: "6px",
              }}
            >
              Parser Ekle
            </Button>
          </Grid>
        )}
      </Grid>
      <ParserConfigCreate
        onClose={() => setisModalOpen(false)}
        open={isModalOpen}
        deviceTypeId={deviceTypeId}
        onSuccess={() => {
          setisModalOpen(false);
          setPage(0);
          loadParserConfigs();
        }}
      />
    </>
  );
};

export default ParserConfigFilter;
